// Per-device inbox preferences (tab, filter, grouping), kept in localStorage.
import { useCallback, useState } from 'react';
import type { InboxFilter, InboxTab } from './model';

export interface InboxPrefs {
  tab: InboxTab;
  filter: InboxFilter;
  unreadOnly: boolean;
  groupByTask: boolean;
}

const KEY = 'atrium.inbox';
const DEFAULTS: InboxPrefs = { tab: 'primary', filter: 'all', unreadOnly: false, groupByTask: true };

function load(): InboxPrefs {
  try {
    return { ...DEFAULTS, ...(JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<InboxPrefs>) };
  } catch {
    return DEFAULTS;
  }
}

export function useInboxPrefs() {
  const [prefs, setPrefs] = useState<InboxPrefs>(load);
  const update = useCallback((changes: Partial<InboxPrefs>) => {
    setPrefs((p) => {
      const next = { ...p, ...changes };
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        /* storage unavailable */
      }
      return next;
    });
  }, []);
  return [prefs, update] as const;
}
